import {useActions, useGetters, useMutators, useState} from './_default';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        ...useState(),
        listUrl: '/payload/paginated/sidebar/poi-group',
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        changeStatus({ state }, group) {
            axios.put('/poi-group/change-status', { id: group.id}).then(() => {
                group.open = !group.open;
            });
        },
    },
}
